import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import CategoryConsosComponent from './CategoryConsosComponent'

function TabContainer({ className, children }) {
  return (
    <Grid className={className} item>
      {children}
    </Grid>
  )
}
TabContainer.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired
}

const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  rootTabs: {
    width: '100%',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  scrollContainer: {
    overflow: 'scroll',
    width: 'calc(100%)',
    height: 'calc(100%)',
    padding: 16
  },
  rootTab: {
    height: 51,
    maxWidth: 'none'
  }
})
export default withStyles(styles, { withTheme: true })(
  class ConsosTabsComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      counter: PropTypes.bool,
      size: PropTypes.string,
      products: PropTypes.array.isRequired,
      categories: PropTypes.array.isRequired,
      addConso: PropTypes.func.isRequired
    }

    state = {
      tabValue: 0,
      color: '#000',
      currentProducts: []
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.products && nextProps.categories) {
        const curProducts = nextProps.products.filter(
          p => nextProps.categories[this.state.tabValue].key === p.category.key
        )
        const color =
          this.props.categories[this.state.tabValue] !== void 0
            ? this.props.categories[this.state.tabValue].color
            : '#000'
        this.setState({
          currentProducts: curProducts,
          color: color
        })
      }
    }
    componentDidMount() {
      const curProducts = this.props.products.filter(
        p => this.props.categories[this.state.tabValue].key === p.category.key
      )
      const color =
        this.props.categories[this.state.tabValue] !== void 0
          ? this.props.categories[this.state.tabValue].color
          : '#000'
      this.setState({
        currentProducts: curProducts,
        color: color
      })
    }
    handleChange = (event, value) => {
      this.setState({
        tabValue: value,
        color: this.props.categories[value].color,
        currentProducts: this.props.products.filter(
          p => this.props.categories[value].key === p.category.key
        )
      })
    }
    render() {
      const { categories, classes } = this.props
      const { tabValue, currentProducts } = this.state
      return (
        <Paper className={classes.container} elevation={3}>
          <Tabs
            className={classes.rootTabs}
            value={tabValue}
            onChange={this.handleChange}
            scrollable
            scrollButtons="auto"
            indicatorColor="secondary">
            {categories.map(category => {
              return (
                <Tab
                  className={classes.rootTab}
                  key={category.key}
                  label={category.name}
                />
              )
            })}
          </Tabs>
          <TabContainer className={classes.scrollContainer}>
            <CategoryConsosComponent
              products={currentProducts}
              color={this.state.color}
              counter={this.props.counter || false}
              size={this.props.size}
              addConso={this.props.addConso}
            />
          </TabContainer>
        </Paper>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Products/components/ConsosTabsComponent.js